namespace $ { $mol_style_attach( "mol/plot/demo/demo.view.css",
 "[mol_plot_demo_saturation] {\n\tstroke-dasharray: .5% .5%;\n}\n"
) }